module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-12day-premium-8511e22fb4abe5e1e9542e0cb5e78dbd.png";